module.exports = __webpack_public_path__ + "img/givemarks-sb.b3e60c43.svg";